import React from "react";
import { Field, Dropdown, Option, Checkbox, Text } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import "../../CSS/IaAgent.css";

const VOICES = [
  { value: "marin", label: "Marin" },
  { value: "cedar", label: "Cedar" },
  { value: "alloy", label: "Alloy" },
  { value: "ash", label: "Ash" },
  { value: "ballad", label: "Ballad" },
  { value: "coral", label: "Coral" },
  { value: "echo", label: "Echo" },
  { value: "sage", label: "Sage" },
  { value: "shimmer", label: "Shimmer" },
  { value: "verse", label: "Verse" },
];

const LANGUAGES = [
  { code: "en", label: "English", serverValue: "English", defaultValue: "En" },
  { code: "fr", label: "French", serverValue: "French", defaultValue: "Fr" },
];

export default function VoiceTab({ agentData, updateField }) {
  const { t } = useTranslation();
  const personality = agentData.agentPersonality || {};
  const langAdapt = agentData.behaviorRules?.languageAdaptation || {};
  const supported = Array.isArray(langAdapt.supportedLanguages) ? langAdapt.supportedLanguages : [];
  const defaultLang = langAdapt.defaultLanguage || "En";

  const selectedVoice = VOICES.find((v) => v.value === personality.voice);

  const toggleLang = (serverValue, checked) => {
    const next = checked
      ? Array.from(new Set([...supported, serverValue]))
      : supported.filter((l) => l !== serverValue);
    updateField("behaviorRules.languageAdaptation.supportedLanguages", next);
  };

  return (
    <div className="ia-agent-tab">
      <Field label={t("VOICE")} className="field-style" required>
        <Dropdown
          value={selectedVoice?.label || personality.voice || ""}
          selectedOptions={personality.voice ? [personality.voice] : []}
          onOptionSelect={(_, d) => updateField("agentPersonality.voice", d.optionValue)}
          placeholder={t("SELECT_VOICE")}
        >
          {VOICES.map((v) => (
            <Option key={v.value} value={v.value} text={v.label}>
              {v.label}
            </Option>
          ))}
        </Dropdown>
      </Field>

      <Field label={t("SUPPORTED_LANGUAGES")} className="field-style">
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {LANGUAGES.map((l) => (
            <Checkbox
              key={l.code}
              label={l.label}
              checked={supported.includes(l.serverValue)}
              onChange={(_, d) => toggleLang(l.serverValue, !!d.checked)}
            />
          ))}
        </div>
      </Field>

      <Field label={t("DEFAULT_LANGUAGE")} className="field-style" required>
        <Dropdown
          value={LANGUAGES.find((l) => l.defaultValue === defaultLang)?.label || defaultLang}
          selectedOptions={[defaultLang]}
          onOptionSelect={(_, d) =>
            updateField("behaviorRules.languageAdaptation.defaultLanguage", d.optionValue)
          }
          placeholder={t("SELECT_DEFAULT_LANGUAGE")}
        >
          {LANGUAGES.map((l) => (
            <Option key={l.code} value={l.defaultValue} text={l.label}>
              {l.label}
            </Option>
          ))}
        </Dropdown>
      </Field>

      <Text className="ia-agent-hint">{t("VOICE_TAB_HINT")}</Text>
    </div>
  );
}
